module.exports = __webpack_public_path__ + "static/img/star_grey.46f13ce5.png";